import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const programAthleteApi = createApi({
  reducerPath: 'programsAthletes',
  tagTypes: ['ProgramAthlete'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchProgramsAthletes: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'ProgramAthlete', id: 'LIST' },
                ...result.map((r) => ({ type: 'ProgramAthlete', id: r.id })),
              ]
            : [{ type: 'ProgramAthlete', id: 'LIST' }],
        query: () => ({
          url: `?resource=program_athlete`,
          method: 'GET',
        }),
      }),

      createProgramAthlete: builder.mutation({
        invalidatesTags: [{ type: 'ProgramAthlete', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=program_athlete`,
          method: 'POST',
          body: data,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      updateProgramAthlete: builder.mutation({
        invalidatesTags: (result, error, { id }) => [
          { type: 'ProgramAthlete', id },
          { type: 'ProgramAthlete', id: 'LIST' },
        ],
        query: ({ id, submitData }) => ({
          url: `?resource=program_athlete&id=eq.${id}`,
          method: 'PATCH',
          body: submitData,
          headers: {
            Prefer: 'return=representation',
            'Content-Type': 'application/json',
          },
        }),
      }),

      deleteProgramAthlete: builder.mutation({
        invalidatesTags: (result, error, id) => [
          { type: 'ProgramAthlete', id },
          { type: 'ProgramAthlete', id: 'LIST' },
        ],
        query: (id) => ({
          url: `?resource=program_athlete&id=eq.${id}`,
          method: 'DELETE',
        }),
      }),

      fetchProgramAthlete: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'ProgramAthlete', id: 'LIST' },
                ...result.map((r) => ({ type: 'ProgramAthlete', id: r.id })),
              ]
            : [{ type: 'ProgramAthlete', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=program_athlete&athlete=eq.${athleteId}&order=created_at.desc&select=*,program(*)`,
          method: 'GET',
        }),
      }),
    };
  },
});

export const {
  useFetchProgramsAthletesQuery,
  useCreateProgramAthleteMutation,
  useUpdateProgramAthleteMutation,
  useDeleteProgramAthleteMutation,
  useFetchProgramAthleteQuery,
} = programAthleteApi;

export { programAthleteApi };
